import { PRODUCT_ERROR } from 'types/product';

// Chuẩn hoá errorCode/status của SKU về 4 giá trị MKT yêu cầu.
export const MAIN_SKU_STATUS = {
  NORMAL: 'normal',
  LIMIT: 'limit',
  OOS: 'oos',
  SUSPENDED: 'suspended',
};

export const mapMainSkuStatus = (code) => {
  switch (code) {
    case PRODUCT_ERROR.OUT_OF_STOCK:
    case PRODUCT_ERROR.OUT_OF_STOCK_SKU:
      return MAIN_SKU_STATUS.OOS;
    case PRODUCT_ERROR.SUSPENDED:
    case PRODUCT_ERROR.SUSPENDED_SKU:
      return MAIN_SKU_STATUS.SUSPENDED;
    case PRODUCT_ERROR.MAX_QUANTITY:
    case PRODUCT_ERROR.CONSUMED_MAX_QUANTITY:
      return MAIN_SKU_STATUS.LIMIT;
    default:
      return MAIN_SKU_STATUS.NORMAL;
  }
};

const PATHS_WITH_RESULT_PAGE = ['/quick-order', '/products'];

// result page chỉ có nghĩa ở Quick Order / Product List (spec MKT).
export const getResultPage = (router) => {
  if (!router || !PATHS_WITH_RESULT_PAGE.includes(router.pathname)) return '';
  return String(router.query?.page || 1);
};

// Gộp nhiều ref (object ref / callback ref) vào một callback ref.
export const mergeRefs = (...refs) => (node) => {
  refs.forEach((ref) => {
    if (typeof ref === 'function') ref(node);
    else if (ref) ref.current = node;
  });
};
